import {
  Navigate,
  useLocation,
  useNavigate,
  useNavigationType,
} from 'react-router'
import { SetupMFA } from 'mfa'
import AccountRecoveryBase from '../../components/AccountRecoveryBase'
import {
  SETUP_MFA_ENFORCED,
  SETUP_TOTP,
  SETUP_WEB_AUTHN,
} from '../../constants/routes'
import { LEARN_MORE_ABOUT_2FA } from '../../constants/accountRecoveryLinks'

function SetupMFAWrapper() {
  const navigate = useNavigate()
  const location = useLocation()
  const navigationType = useNavigationType()

  // Only reachable via SetupMFAEnforced's onSetupMfa, which navigates here
  // with the freshly-registered recoveryCodeList in state. A direct/refreshed
  // visit has no such state, and the shared SetupMFA page's RecoveryOTPList
  // dereferences `.length` on it unconditionally — send those back to the
  // entry point instead of crashing.
  if (!location.state?.recoveryCodeList) {
    return <Navigate to={SETUP_MFA_ENFORCED} replace />
  }

  return (
    <AccountRecoveryBase.Centered>
      <SetupMFA
        location={location}
        history={{ action: navigationType }}
        enabledMFAMechanisms={[]}
        hasAllMFAEnabled={false}
        learnMoreAbout2FAUrl={LEARN_MORE_ABOUT_2FA}
        onSetupWebAuthn={() =>
          navigate(SETUP_WEB_AUTHN, { state: location.state })
        }
        onSetupTOTP={() => navigate(SETUP_TOTP, { state: location.state })}
      />
    </AccountRecoveryBase.Centered>
  )
}

export default SetupMFAWrapper
